<template>
	<footer class="footer">
		<div class="top">
			<div class="container">
				<p>
					SCRABBLE®, Words With Friends®, Word Chums® and Jumble® are
					the property of their respective trademark owners. These
					trademark owners are not affiliated with, and do not endorse
					and/or sponsor, LoveToKnow®, its products or its websites,
					including
					<a href="https://www.yourdictionary.com/" rel="follow">
						yourdictionary.com.
					</a>
					Use of this trademark on
					<a href="https://www.yourdictionary.com/" rel="follow">
						yourdictionary.com.
					</a>
					is for informational purposes only.
				</p>
			</div>
		</div>
		<div class="container">
			<div class="bottom">
				<div class="left">
					<router-link
						to="/"
						class="logo"
						:aria-label="$t('WordscapesHeaderLogoText')"
					>
						<span
							:aria-label="$t('WordscapesHeaderLogoText')"
							:class="
								isSmallDevice
									? `logo-sprite--ws-mobile`
									: `logo-sprite--ws-desktop`
							"
							class="logo-sprite"
							role="img"
						/>
					</router-link>
					<ul v-if="isSmallOrMediumDevice" class="project-links">
						<li
							v-for="link in projectLinks"
							:key="$t(link.labelDictionaryKey)"
						>
							<a
								:href="$t(link.linkDictionaryKey)"
								:title="$t(link.titleAttrDictionaryKey)"
								rel="follow"
								target="_blank"
							>
								<span>
									<picture>
										<source
											:srcset="link.imageURLWebp"
											type="image/webp"
										/>
										<img
											:src="link.imageURL"
											:alt="$t(link.labelDictionaryKey)"
											width="32"
										/>
									</picture>
								</span>
								<span>{{ $t(link.labelDictionaryKey) }}</span>
							</a>
						</li>
					</ul>
				</div>
				<nav class="right">
					<ul class="footer-links">
						<li
							v-for="link in footerLinks"
							:key="$t(link.labelDictionaryKey)"
						>
							<a
								:href="$t(link.linkDictionaryKey)"
								:title="$t(link.labelDictionaryKey)"
								:rel="link.rel"
								:target="link.target ? link.target : null"
								@click="handleClick(link.eventAction)"
							>
								{{ $t(link.labelDictionaryKey) }}
							</a>
						</li>
						<li class="footer-link footer-link--right">
							<a
								:href="$t('FooterCcpaUrl')"
								:title="$t('FooterCcpaText')"
								rel="follow"
								@click="
									handleClick(
										`Click on CCPA ${this.$t(
											'FooterCcpaText'
										)}`
									)
								"
							>
								{{ $t("FooterCcpaText") }}
							</a>
						</li>
						<li class="footer-link footer-link--right">
							<a
								title="Cookie Settings"
								@click="onOneTrustLinkClick"
							>
								Cookie Settings
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: "Footer",
	data() {
		return {
			footerLinks: [
				{
					linkDictionaryKey: "FooterCompanyUrl",
					labelDictionaryKey: "FooterCompanyText",
					eventAction: `Click on About ${this.$t(
						"FooterCompanyText"
					)}`,
				},
				{
					linkDictionaryKey: "FooterContactUrl",
					labelDictionaryKey: "FooterContactText",
					eventAction: `Click on Contact ${this.$t(
						"FooterContactText"
					)}`,
				},
				{
					linkDictionaryKey: "FooterPrivacyPolicyUrl",
					labelDictionaryKey: "FooterPrivacyPolicyText",
					eventAction: `Click on Privacy ${this.$t(
						"FooterPrivacyPolicyText"
					)}`,
				},
				{
					linkDictionaryKey: "FooterTermsOfUseUrl",
					labelDictionaryKey: "FooterTermsOfUseText",
					eventAction: `Click on Terms ${this.$t(
						"FooterTermsOfUseText"
					)}`,
				},
				{
					linkDictionaryKey: "FooterSuggestionsUrl",
					labelDictionaryKey: "FooterSuggestionsText",
					eventAction: `Click on Suggestions ${this.$t(
						"FooterSuggestionsText"
					)}`,
					rel: "nofollow",
					target: "_blank",
				},
			],
			projectLinks: [
				{
					linkDictionaryKey: "WordscapesFooterIconUrlWfEn",
					labelDictionaryKey: "WordscapesFooterIconTextWfEn",
					titleAttrDictionaryKey:
						"WordscapesFooterIconTitleAttributeWfEn",
					imageURL: "/static/images/ic-ws_wf.png",
					imageURLWebp: "/static/images/ic-ws_wf.webp",
				},
				{
					linkDictionaryKey: "WordscapesFooterIconUrlYdr",
					labelDictionaryKey: "WordscapesFooterIconTextYdr",
					titleAttrDictionaryKey:
						"WordscapesFooterIconTitleAttributeYdr",
					imageURL: "/static/images/ic-ws_yd.png",
					imageURLWebp: "/static/images/ic-ws_yd.webp",
				},
			],
		};
	},
	methods: {
		handleClick(eventAction) {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Footer",
				eventAction: eventAction,
			});
		},
		onOneTrustLinkClick(event) {
			const OTLink = document.getElementById("ot-sdk-btn");
			if (OTLink) {
				OTLink.click();
			}
		},
	},
};
</script>

<style lang="scss" scoped src="./styles.scss"></style>
